module.exports = __webpack_public_path__ + "static/media/Change_Password.2df94894.svg";